// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-quartz {
  --ag-background-color: 'transparent';
  /* --ag-background-color: white; */
  --ag-header-column-separator-display: 'none';
  --ag-checkbox-background-color: #E0E0E0;
  --ag-checkbox-checked-color: var(--primary-color);
  --ag-checkbox-unchecked-color: var(--background-color);
  --ag-checkbox-indeterminate-color: white;


  --ag-header-column-separator-width: 0px !important;
}

.ag-theme-quartz .ag-popup {
  background-color: white !important;
}

.ag-root-wrapper{
  border: none;
  border-radius: 8px 8px 0px 0px;
}


.ag-ltr .ag-cell {
  /* border-right: 1px solid #ccc !important; */
  color: var(--text-color) !important;
  text-align: left !important;
  font-size: 12px !important;
}

.ag-header-cell {
  /* background-color: var(--primary-color) !important;*/
  border: 1px solid #ccc !important;

  background: #D7DEE6 !important;
  color: #fff !important;
}

.ag-header-cell-text {
  /* color: #344049 !important; */
  color: #344049;
  font-family: Jost;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 250%;
}

.editvaluedata {
  color: var(--text-color) !important;
  text-align: left !important;
  font-size: 12px !important;

}


.ag-cell[col-id='country'] {
  overflow: visible !important;
}

.npi-title {
  color: rgba(0, 144, 248, 1) !important;
}

.ag-popup {
  background-color: white !important;
  /* Custom popup background color */
}


/* Additional specific styling if needed */
.ag-popup .ag-menu {
  background-color: white !important;
  /* Custom menu background color within popup */
}

.ag-tabs-header .ag-menu-header {
  background-color: white !important;
}

.ag-popup .ag-tabs {
  background-color: white;
}

.ag-popup .ag-tab-selected {
  background-color: white;
}

.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {
  color: #fffff1 !important;
}

.old-value-text {
  color: var(--error-color);
  text-decoration: line-through;
  margin-right: 5px;
  font-size: 12px;
}

.new-value-text {
  color: var(--secondary-color);
}

.ag-ltr .ag-header-cell-resize {
  opacity: 0;
}


.ag-body-viewport-wrapper.ag-layout-normal {
  overflow-x: scroll;
  overflow-y: scroll;
}


.edited-cell-custom {
  /* background-color: #E6FFFB !important; */
  background-color: #E5EDFF !important;
  /* border-radius: 10px !important; */
}


div.ag-row-hover:not(.ag-row-group) div {
  background-color: #f8dbdb !important;
 
}

.ag-row{
  border-bottom: 4px solid #f8f8f8 !important;
  border-top: 4px solid #f8f8f8 !important;
}

.ag-header {
  border: none; /* Remove header border */
}

/* Remove borders from header cells */
.ag-header-cell {
  border: none; /* Remove borders from header cells */
}

.ag-row {
  border: none; /* Remove border for rows */
}

/* Remove borders around individual cells */
.ag-cell {
  border: none; /* Remove cell borders */
}

/* .ag-header-cell {
  border-right: 1px solid #ccc; 
} */

.ag-header-cell:last-child {
  border-right: none; /* Remove the line from the last header cell */
}

.ag-header-cell:last-child::after {
  display: none; /* Remove the line from the last header cell */
}

.ag-header-cell-resize {
  height: 10px; /* Set a custom height */
  top: 50%; /* Vertically center the resize handle */
  margin-top: -5px; /* Adjust the position if needed */
}
/* div.ag-row-hover .ag-cell-inline-editing div {
  color: black;
} */


/* Custom styles for the header menu button */
.ag-header-icon.ag-header-cell-menu-button {
  color: white !important;
  fill: white !important;
}

/* .ag-theme-quartz .ag-header-cell-menu-button {
  background-color: white;
  color: black;
}

.ag-theme-quartz .ag-header-cell-menu-button:hover {
  background-color: #f5f5f5;
} */

/* .ag-header-cell-comp-wrapper .ag-icon-menu{
  color: white !important;
}


.ag-header-cell-comp-wrapper .ag-icon-asc{
  color: white !important;
}

.ag-header-cell-comp-wrapper .ag-icon-desc{
  color: white !important;
}

.ag-header-cell-comp-wrapper .ag-icon-filter{
  color: white !important;
} */

.ag-paging-panel {
  font-size: 12px !important;
}

/* Target the page size dropdown */
.ag-paging-panel .ag-page-size-select {
  background-color: #e0f7fa;
  /* Change to your desired background color */
  border: 1px solid #00796b;
  /* Optional: Add a border color */
  color: #00796b;
  /* Optional: Change text color */
}

/* Optional: Change the dropdown options background and text color */
.ag-paging-panel .ag-page-size-select option {
  background-color: #e0f7fa;
  /* Same as dropdown background color */
  color: #00796b;
  /* Same as dropdown text color */
  opacity: 1;
}

.ag-floating-filter .ag-floating-filter-input .ag-text-field-input-wrapper .ag-input-field-input {
  border: none !important;
  color: #344049 !important;
  font-weight: 400 !important;
}

/* .ag-icon-menu::before{
  content: '\\f11e'
} */

.cellCenter .ag-cell-wrapper {
  margin-left: '30px !important'
}

.edited-cell {
  border-radius: 10px;
  /* Additional styling as needed */
}

.ag-row-odd{
  background-color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/AgGridCustom.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,4CAA4C;EAC5C,uCAAuC;EACvC,iDAAiD;EACjD,sDAAsD;EACtD,wCAAwC;;;EAGxC,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;;AAGA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,iCAAiC;;EAEjC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;;AAE5B;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;;AAGA,0CAA0C;AAC1C;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,oCAAoC;AACtC;;;AAGA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,YAAY,EAAE,yBAAyB;AACzC;;AAEA,qCAAqC;AACrC;EACE,YAAY,EAAE,qCAAqC;AACrD;;AAEA;EACE,YAAY,EAAE,2BAA2B;AAC3C;;AAEA,2CAA2C;AAC3C;EACE,YAAY,EAAE,wBAAwB;AACxC;;AAEA;;GAEG;;AAEH;EACE,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA;EACE,aAAa,EAAE,8CAA8C;AAC/D;;AAEA;EACE,YAAY,EAAE,wBAAwB;EACtC,QAAQ,EAAE,wCAAwC;EAClD,gBAAgB,EAAE,kCAAkC;AACtD;AACA;;GAEG;;;AAGH,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;EACd,gCAAgC;AAClC;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;EACd,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["@import './variables.css';\n\n.ag-theme-quartz {\n  --ag-background-color: 'transparent';\n  /* --ag-background-color: white; */\n  --ag-header-column-separator-display: 'none';\n  --ag-checkbox-background-color: #E0E0E0;\n  --ag-checkbox-checked-color: var(--primary-color);\n  --ag-checkbox-unchecked-color: var(--background-color);\n  --ag-checkbox-indeterminate-color: white;\n\n\n  --ag-header-column-separator-width: 0px !important;\n}\n\n.ag-theme-quartz .ag-popup {\n  background-color: white !important;\n}\n\n.ag-root-wrapper{\n  border: none;\n  border-radius: 8px 8px 0px 0px;\n}\n\n\n.ag-ltr .ag-cell {\n  /* border-right: 1px solid #ccc !important; */\n  color: var(--text-color) !important;\n  text-align: left !important;\n  font-size: 12px !important;\n}\n\n.ag-header-cell {\n  /* background-color: var(--primary-color) !important;*/\n  border: 1px solid #ccc !important;\n\n  background: #D7DEE6 !important;\n  color: #fff !important;\n}\n\n.ag-header-cell-text {\n  /* color: #344049 !important; */\n  color: #344049;\n  font-family: Jost;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 250%;\n}\n\n.editvaluedata {\n  color: var(--text-color) !important;\n  text-align: left !important;\n  font-size: 12px !important;\n\n}\n\n\n.ag-cell[col-id='country'] {\n  overflow: visible !important;\n}\n\n.npi-title {\n  color: rgba(0, 144, 248, 1) !important;\n}\n\n.ag-popup {\n  background-color: white !important;\n  /* Custom popup background color */\n}\n\n\n/* Additional specific styling if needed */\n.ag-popup .ag-menu {\n  background-color: white !important;\n  /* Custom menu background color within popup */\n}\n\n.ag-tabs-header .ag-menu-header {\n  background-color: white !important;\n}\n\n.ag-popup .ag-tabs {\n  background-color: white;\n}\n\n.ag-popup .ag-tab-selected {\n  background-color: white;\n}\n\n.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {\n  color: #fffff1 !important;\n}\n\n.old-value-text {\n  color: var(--error-color);\n  text-decoration: line-through;\n  margin-right: 5px;\n  font-size: 12px;\n}\n\n.new-value-text {\n  color: var(--secondary-color);\n}\n\n.ag-ltr .ag-header-cell-resize {\n  opacity: 0;\n}\n\n\n.ag-body-viewport-wrapper.ag-layout-normal {\n  overflow-x: scroll;\n  overflow-y: scroll;\n}\n\n\n.edited-cell-custom {\n  /* background-color: #E6FFFB !important; */\n  background-color: #E5EDFF !important;\n  /* border-radius: 10px !important; */\n}\n\n\ndiv.ag-row-hover:not(.ag-row-group) div {\n  background-color: #f8dbdb !important;\n \n}\n\n.ag-row{\n  border-bottom: 4px solid #f8f8f8 !important;\n  border-top: 4px solid #f8f8f8 !important;\n}\n\n.ag-header {\n  border: none; /* Remove header border */\n}\n\n/* Remove borders from header cells */\n.ag-header-cell {\n  border: none; /* Remove borders from header cells */\n}\n\n.ag-row {\n  border: none; /* Remove border for rows */\n}\n\n/* Remove borders around individual cells */\n.ag-cell {\n  border: none; /* Remove cell borders */\n}\n\n/* .ag-header-cell {\n  border-right: 1px solid #ccc; \n} */\n\n.ag-header-cell:last-child {\n  border-right: none; /* Remove the line from the last header cell */\n}\n\n.ag-header-cell:last-child::after {\n  display: none; /* Remove the line from the last header cell */\n}\n\n.ag-header-cell-resize {\n  height: 10px; /* Set a custom height */\n  top: 50%; /* Vertically center the resize handle */\n  margin-top: -5px; /* Adjust the position if needed */\n}\n/* div.ag-row-hover .ag-cell-inline-editing div {\n  color: black;\n} */\n\n\n/* Custom styles for the header menu button */\n.ag-header-icon.ag-header-cell-menu-button {\n  color: white !important;\n  fill: white !important;\n}\n\n/* .ag-theme-quartz .ag-header-cell-menu-button {\n  background-color: white;\n  color: black;\n}\n\n.ag-theme-quartz .ag-header-cell-menu-button:hover {\n  background-color: #f5f5f5;\n} */\n\n/* .ag-header-cell-comp-wrapper .ag-icon-menu{\n  color: white !important;\n}\n\n\n.ag-header-cell-comp-wrapper .ag-icon-asc{\n  color: white !important;\n}\n\n.ag-header-cell-comp-wrapper .ag-icon-desc{\n  color: white !important;\n}\n\n.ag-header-cell-comp-wrapper .ag-icon-filter{\n  color: white !important;\n} */\n\n.ag-paging-panel {\n  font-size: 12px !important;\n}\n\n/* Target the page size dropdown */\n.ag-paging-panel .ag-page-size-select {\n  background-color: #e0f7fa;\n  /* Change to your desired background color */\n  border: 1px solid #00796b;\n  /* Optional: Add a border color */\n  color: #00796b;\n  /* Optional: Change text color */\n}\n\n/* Optional: Change the dropdown options background and text color */\n.ag-paging-panel .ag-page-size-select option {\n  background-color: #e0f7fa;\n  /* Same as dropdown background color */\n  color: #00796b;\n  /* Same as dropdown text color */\n  opacity: 1;\n}\n\n.ag-floating-filter .ag-floating-filter-input .ag-text-field-input-wrapper .ag-input-field-input {\n  border: none !important;\n  color: #344049 !important;\n  font-weight: 400 !important;\n}\n\n/* .ag-icon-menu::before{\n  content: '\\f11e'\n} */\n\n.cellCenter .ag-cell-wrapper {\n  margin-left: '30px !important'\n}\n\n.edited-cell {\n  border-radius: 10px;\n  /* Additional styling as needed */\n}\n\n.ag-row-odd{\n  background-color: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
